<template>
  <main>
    <van-nav-bar title="关于我们" left-arrow @click-left="onClickLeft" />

    <p class="small" style="margin-top:50px">
      &nbsp;&nbsp;&nbsp;&nbsp;福建百旺金赋信息科技有限公司是经国家信息安全工程技术研究中心授权的福建省(除厦门)地区增值税发票税控系统的服务单位，承担国家“金税工程”中的重要部分—增值税发票税控系统在福建省(除厦门)的推广与技术服务。
      公司自成立以来，依托国家信息安全工程技术研究中心和集团公司的技术、人才、资源和管理等方面的综合优势，一直专注于信息安全类产品的开发、销售和技术服务。公司主要致力于提供面向政府、税务的信息安全产品和技术服务。目前，公司已经纳入了快速、稳定、健康、科学的发展轨道，公司具有健全的营销和服务网络，以信心服务的理念服务客户，产生了较大的社会和经济效益。
      目前，总公司建有百旺呼叫中心（40061-12366），为纳税人提供业务咨询、软件使用、故障排除等7*24小时远程技术支持服务，同时，福建百旺公司也已建成覆盖全省各区县的营销和服务网络，拥有各类技术服务人员200余人，可以为全省客户提供长期的本地化服务。
      用心服务，贴心用户。百旺金赋始终秉承“用户的满意就是我们最大的成功”、“用户的赞誉就是我们最大的信心”的经营理念和品牌承诺，愿同社会各界朋友真诚合作，用实际行动践行我们“百旺、百旺、百业兴旺”的企业愿景。
      百旺金赋以人为本、励精图治，管理水平不断跃上新的台阶。公司对人才十分重视，并把人才的吸引、培养和使用看成公司健康稳定发展的根本。公司建立了一支以高学历、高素质、年富力强的多方面人才为骨干的专业技术服务团队，队伍稳定且工作高效。公司实施有效的管理制度，逐步提升员工的薪酬待遇与发展空间，全面构造公司的核心竞争力，努力成为信息技术专家和卓越品质的创造者。
    </p>
  </main>
</template>

<script>
export default {
  data() {},
  methods: {
    onClickLeft() {
      this.$router.push({ path: "/user" });
    },
  },
};
</script>
<style scoped>
p.small {
  line-height: 1.5;
  margin: 10px 10px;;
}
</style>